import type { ChakraProps } from '@chakra-ui/react';
import { Flex, HStack, Image, Link } from '@chakra-ui/react';
import { getAssetUrl } from '@cronos-app/chakra';
import React from 'react';

import { WalletNavItem } from './WalletNavItem';

type TopNavbarProps = ChakraProps;
export const TopNavbar = (props: TopNavbarProps) => {
  return (
    <Flex align="center" justifyContent="center" px="20px" py="16px" {...props}>
      <HStack maxW="1280px" justify="space-between" flex="1 1 auto">
        <Link href="https://cronos.org/">
          <Image
            src={getAssetUrl('/images/text-logo-cronos-evm.png')}
            w="84px"
            h="auto"
            alt="Cronos EVM"
          />
        </Link>
        <WalletNavItem />
      </HStack>
    </Flex>
  );
};
